import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { initClientFeatures } from '@ip-only/client-features';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

initClientFeatures(environment.clientFeatures);

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
